// extracted by mini-css-extract-plugin
module.exports = {"ul":"j93yMml","li":"_3H4VztY"};